import {stringify} from 'qs'
import request from 'crm/utils/request'
import {format} from 'utils/index'
import api from './api'

// 获取朋友圈参数-列表
export async function getMomentsParamsList(payload) {
    return request(`${api.getMomentsParamsList.url}?${stringify(payload?.params)}`)
}

// 批量-设置朋友圈参数
export async function editMomentsParams(payload) {
    return request(format(`${api.editMomentsParams.url}`), {
        method: api.editMomentsParams.type,
        body: payload.body,
    })
}
